import { render, staticRenderFns } from "./ButtonWhatSapp.vue?vue&type=template&id=1de07e7d&"
import script from "./ButtonWhatSapp.vue?vue&type=script&lang=js&"
export * from "./ButtonWhatSapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports